'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usersListURL = exports.usersLinkURL = exports.refreshURL = exports.profileURL = exports.authJWTURL = exports.authURL = undefined;

var _reselect = require('reselect');

var configSelector = function configSelector(state) {
    return state.config;
};

var authURL = exports.authURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return function (username, password) {
        return config.auth.OAUTHUrl + '/auth/token?grant_type=password&client_id=' + config.auth.OAUTHClientId + '&client_secret=' + config.auth.OAUTHSecret + '&scope=all&username=' + username + '&password=' + password;
    };
});

var authJWTURL = exports.authJWTURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return config.auth.OAUTHUrl + '/auth/token';
});

var profileURL = exports.profileURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return function (userId) {
        return config.auth.OAUTHUrl + '/users/' + (userId || 'me');
    };
});

// /auth/token?grant_type=refresh_token&client_id=%s&client_secret=%s&state=xyz&redirect_uri=%s&refresh_token=%s
var refreshURL = exports.refreshURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return function (refreshToken) {
        return config.auth.OAUTHUrl + '/auth/token?grant_type=refresh_token&client_id=' + config.auth.OAUTHClientId + '&client_secret=' + config.auth.OAUTHSecret + '&refresh_token=' + refreshToken;
    };
});

var usersLinkURL = exports.usersLinkURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return function () {
        return config.auth.OAUTHUrl + '/users/';
    };
});

var usersListURL = exports.usersListURL = (0, _reselect.createSelector)(configSelector, function (config) {
    return function () {
        return config.auth.OAUTHUrl + '/users/?per_page=1000&realm=jlrconnect';
    };
});
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/selectors/auth.js
// module id = 1291
// module chunks = 5